import React, { FC } from "react";
import "./StatusIcon.scss";

export type StatusIconProps = {
  type: "warning" | "danger" | "info";
  size?: number;
  marginRight?: string;
};

const StatusIcon: FC<StatusIconProps> = ({
  type,
  size = 16,
  marginRight = "5px",
}) => {
  const getIconClass = () => {
    switch (type) {
      case "danger":
        return "bi-exclamation-circle";
      case "info":
        return "bi-info-circle";
      case "warning":
      default:
        return "bi-exclamation-circle";
    }
  };

  return (
    <span
      className={`bi ${getIconClass()} status-icon status-icon--${type}`}
      style={{
        marginRight,
        fontSize: `${size}px`,
      }}
    />
  );
};

export default StatusIcon;
